import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

// ✏️ CAMBIA ESTO EN CADA PROYECTO: 'colpraz', 'iguau', 'proyecto3', etc.
const NOMBRE_PROYECTO = 'colpraz'; 

@Injectable({
  providedIn: 'root'
})
export class WebsocketService {
  private socket!: WebSocket;
  private socketData$ = new Subject<any>();

  constructor() {
    // Volvemos a conectar automáticamente desde el inicio
    this.conectar();
  }

  private conectar() {
    console.log(`Iniciando WebSocket para el proyecto de forma automática: ${NOMBRE_PROYECTO}`);
    
    // URL base única redirigida por Nginx + el nombre estático de este proyecto
    const urlBase = 'wss://devwebsite.es/websocketserver';
    this.socket = new WebSocket(`${urlBase}/${NOMBRE_PROYECTO}`);

    this.socket.onopen = () => {
      console.log(`¡Conectado con éxito al canal de [${NOMBRE_PROYECTO}]! 🎉`);
    };

    this.socket.onmessage = (event) => {
      try {
        const datos = JSON.parse(event.data);
        this.socketData$.next(datos);
      } catch (e) {
        // En caso de que recibas texto plano
        this.socketData$.next(event.data);
      }
    };

    this.socket.onclose = (event) => {
      console.log(`Conexión de ${NOMBRE_PROYECTO} cerrada. Reconectando en 5 segundos...`, event);
      setTimeout(() => this.conectar(), 5000);
    };

    this.socket.onerror = (error) => {
      console.error(`Error en el WebSocket de ${NOMBRE_PROYECTO}:`, error);
    };
  }

  // Enviar datos al servidor
  enviarNotificacion(contenido: any) {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(JSON.stringify(contenido));
    } else {
      console.error('No se pudo enviar, el WebSocket no está conectado.');
    }
  }

  // Escuchar desde los componentes
  escucharNotificaciones(): Observable<any> {
    return this.socketData$.asObservable();
  }
}